import { PetType } from './Pet';

export interface PetForm {
    uuid: string;
    id: number;
    name: string;
    breed?: string | null;
    size?: string | null;
    petType: PetType;
    imageUrl: string;
    formsStatus: 'Pending' | 'Completed';
}

export enum FormStatus {
    Pending = 'Pending',
    Completed = 'Completed'
}

// Frontend types (camelCase)
export interface ResponseData {
    id: number;
    answer: string;
    questionSnapshot: string;
}

export interface FormQuestion {
    id: number;
    question: string;
    type: 'text' | 'textarea' | 'radio' | 'checkbox';
    required: boolean;
    options?: FormQuestionOption[];
    answer?: string | string[]; // Pre-filled answer from backend
    response?: ResponseData | null; // Complete response data from backend
    answerType?: 'short_answer' | 'long_answer' | 'single_choice' | 'multiple_choice';
}

export interface FormQuestionOption {
    id: number;
    active: boolean;
    label: string;
    value: string;
    position: number;
}

export interface ConvertedForm {
    id: number;
    name: string;
    status: FormStatus;
    questions: FormQuestion[];
}

export interface ConvertedCustomerData {
    id: number;
    name: string;
    lastName: string;
    fullName: string;
    email: string;
    phone: string;
    forms: ConvertedForm[];
}

export interface ConvertedPetData {
    uuid: string;
    id: number;
    name: string;
    breed?: string | null;
    size?: string | null;
    petType?: string | null;
    image_url?: string | null;
    formsStatus: 'Pending' | 'Completed';
}

export interface ConvertedFormsInvitation {
    invitation: {
        id: number;
        token: string;
        status: string;
    };
    customer: ConvertedCustomerData;
    pets: PetForm[];
    petForms: { [petUuid: string]: ConvertedForm[] };
}
